import axios from "axios";
import store from "@/store";

const ApiClients = {

  install(Vue, options) {
    if (options.accessToken) {
      Vue.prototype.$userClient = generateClient({
          baseURL: options.userApiUrl,
          headers: { Authorization: "Bearer " + options.accessToken },
      })
    }
    else {
      Vue.prototype.$userClient = generateClient({
          baseURL: options.userApiUrl + '/br/' + options.appName,
      })
    }

    Vue.prototype.$frontendClient = generateClient({
      baseURL: options.frontendApiUrl,
    });

    function generateClient(clientConfig) {
      const client = axios.create({timeout: 5000, ...clientConfig });

      return async function(args) {
        try {
          store.dispatch("axiosBusy");
          const response = await client.request(args);
          store.dispatch("axiosIdle");
          return response.data;
        } catch (error) {
          store.dispatch("axiosIdle");
          let message = {
            type: "error"
          };
          if (error.response) {
            message.message =
              "HTTP " + error.response.status + ": " + error.response.data.message;
          } else if (error.request) {
            message.message = "Could not send request" + error.request;
          } else {
            message.message = "Unknown axios error: " + error.message;
          }
          alert(message.message);
          throw error;
        }
      }
    }


  }
};

export default ApiClients;
